'use client';

import {
  SiteSearchRecentSearches,
  SiteSearchSectionLabel,
  SiteSearchTopicLink,
} from '@/components/SiteSearch';
import { SEARCH_UI_POPULAR_TOPICS } from '@/constants';
import { searchPath } from '@/helpers/linkHelpers';
import ArrowRight from '@/icons/react/ArrowRight';
import { useSiteSearch } from '@/providers';

export function SiteSearchResults() {
  const { query } = useSiteSearch();

  return <>{query ? <QueryResultsState /> : <NoQueryResultsState />}</>;
}

function QueryResultsState() {
  const { results, query } = useSiteSearch();

  return (
    <>
      <div className="mb-4">
        <SiteSearchTopicLink
          slug={query}
          label={
            <span className="flex items-center gap-3">
              <span>
                Show all results for &ldquo;
                <span className="bg-yellow-200 text-black dark:bg-yellow-700 dark:text-paper">
                  {query}
                </span>
                &rdquo;
              </span>
              <ArrowRight className="translate-y-px" />
            </span>
          }
          name={query}
          updateRecent={false}
          linkURL={searchPath(query)}
          listContext="goto-search"
        />
      </div>

      <SiteSearchSectionLabel label={`Topics matching "${query}"`} />

      {results.map(
        (result, index) =>
          result?.name &&
          result?.slug && (
            <SiteSearchTopicLink
              key={result.id + result.slug}
              id={result.id}
              slug={result.slug}
              label={result.name}
              name={result.name}
              index={index}
              listContext="topics-matching"
            />
          ),
      )}
    </>
  );
}

function NoQueryResultsState() {
  const { recentSearches } = useSiteSearch();

  return (
    <>
      {recentSearches && <SiteSearchRecentSearches />}

      <SiteSearchSectionLabel
        label="Popular Topics"
        addTopMargin={!!recentSearches?.length}
      />
      {SEARCH_UI_POPULAR_TOPICS.map(
        (topic: { name: string; slug: string }, index) => (
          <SiteSearchTopicLink
            key={topic.slug}
            slug={topic.slug}
            label={topic.name}
            name={topic.name}
            listContext="popular-topics"
            index={index}
          />
        ),
      )}
    </>
  );
}
